import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bolt.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ac44f6b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-provider-item-logo" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "payment-provider-item-container" }
const _hoisted_4 = { class: "payment-provider-item-text" }
const _hoisted_5 = { class: "payment-provider-item-tooltip" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "Rápido",
  style: {"margin-right":"5px","margin-top":"auto","margin-bottom":"auto"}
}
const _hoisted_7 = ["id"]
const _hoisted_8 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.paymentProvider.showGrouped)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "payment-provider-item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.paymentProvider.logo,
            alt: _ctx.paymentProvider.displayName,
            class: _normalizeClass({ 'disabled-logo': !_ctx.paymentProvider.enabled })
          }, null, 10, _hoisted_2)
        ]),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.paymentProvider.displayName)), 1),
          _createElementVNode("span", _hoisted_5, [
            (_ctx.paymentProvider.toolTip === 'Rápido')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.paymentProvider.toolTip), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        id: _ctx.paymentProvider.displayName.replace(/[\s']/g, '-').toLowerCase(),
        class: "payment-provider-item-grouped",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.paymentProvider.logo,
          alt: _ctx.paymentProvider.displayName,
          class: _normalizeClass({ 'disabled-logo': !_ctx.paymentProvider.enabled })
        }, null, 10, _hoisted_8)
      ], 8, _hoisted_7))
}